module.exports = "/_next/static/images/banner_app_id-b3c312013d4ecab8d986c0d2c9882137.jpg";